export default "__VITE_ASSET__2L1ZxIp4__"